import Vue from 'vue';

import ClaimView from './views/ClaimView.vue';
import LoginView from './views/LoginView.vue';
import MyClaimsView from './views/MyClaimsView.vue';
import SignupView from './views/SignupView.vue';
import VerifySignupView from './views/VerifySignupView.vue';
import SomethingWrong from './views/errors/SomethingWrong.vue';

import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    { path: '/signup', name: 'Signup', component: SignupView, meta: { public: true, layout: 'CenteredBox' } },
    { path: '/verify/:token', name: 'VerifySignup', component: VerifySignupView, props: true, meta: { public: true, layout: 'CenteredBox' } },
    { path: '/login', name: 'Login', component: LoginView, meta: { public: true, layout: 'CenteredBox' } },
    { path: '/error', name: 'Error', component: SomethingWrong, meta: { public: true, layout: 'CenteredBox' } },
    { path: '/claims', name: 'MyClaims', component: MyClaimsView },
    { path: '/claims/:id', name: 'Claim', component: ClaimView, props: true },
    { path: '/claims(/[a-zA-Z0-9]+)*/:id', name: 'ChildClaim', component: ClaimView, props: true },
    { path: '/', redirect: '/login' },
];

const router = new VueRouter({
    mode: 'history',
    routes
});

router.beforeEach((to, from, next) => {
    const session = localStorage.getItem('truthtree-session');
    if (to.path === '/login' && session) {
        next({
            name: 'MyClaims'
        });
    } else if (to.matched.some(record => !record.meta.public) && !session) {
        next({ 
            path: '/login',
            query: { redirect: to.fullPath }
        });
    } else {
        next();
    }
});

export { router };
